export default __webpack_public_path__ + "static/media/apca.04e19a90.png";